import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadNas = () => {
    const promiseNas = new Promise((resolve, reject) => {
        loader.load(
            "office/model/nas/nas.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                model.position.set(1.569184297236487, 1.0219781401189747, 4.0814242733669);
                model.scale.set(0.255, 0.255, 0.255);
                model.rotation.set(0, 0.23085348312716106, 0);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseNas;
};

export { loadNas };
